import Tariff from "./Tariff";
export default Tariff;
